import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Button, Modal } from "react-bootstrap";
import TablePagination from "./TablePagination";
import { getTodayFollowups as getStallFollowups } from "../Apis/StallEnquiryAPIs";
import { toast } from "react-toastify";
import { formatDate } from "../helper/DateHelper";

const TodayFollowupLayer = () => {
    const [activeTab] = useState("stall");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);

    const fetchFollowups = async () => {
        try {
            setLoading(true);
            const params = {
                page: currentPage,
                limit: rowsPerPage,
                search: searchTerm || undefined,
            };

            const result = await getStallFollowups(params);

            if (result.status) {
                setData(result.response.data || []);
                setTotalRecords(result.response.total || 0);
            }
        } catch (error) {
            console.error("Error fetching followups:", error);
            toast.error("Failed to fetch followups");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFollowups();
    }, [currentPage, rowsPerPage, searchTerm]);

    const customStyles = `
        .glass-action-btn {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            text-decoration: none;
            cursor: pointer;
        }
        .glass-action-btn:hover {
            transform: translateY(-2px) scale(1.08);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }
        .glass-btn-view {
            background-color: #eef2ff;
            color: #4f46e5;
            border: 1px solid #e0e7ff;
        }
        .glass-btn-view:hover {
            background-color: #4f46e5;
            color: #ffffff;
            border-color: #4f46e5;
        }
    `;

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden border-0 shadow-sm">
            <style>{customStyles}</style>
            <div className="card-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #000000, #bb0007, #ed1c24)" }}>
                <div className="d-flex align-items-center gap-4">
                    <h6 className="text-white mb-0 fw-bold">Today Followup</h6>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <div className="position-relative" style={{ width: "250px" }}>
                        <input
                            type="text"
                            className="form-control radius-8 ps-40 py-10 bg-white border-0"
                            style={{ height: "44px" }}
                            placeholder="Search stall..."
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(0);
                            }}
                        />
                        <Icon icon="ion:search-outline" className="position-absolute start-0 top-50 translate-middle-y ms-12 text-dark opacity-75" />
                    </div>
                </div>
            </div>
            <div className="card-body p-24">
                <div className="table-responsive border radius-8 bg-white overflow-x-auto shadow-sm">
                    <table className="table bordered-table sm-table mb-0" style={{ minWidth: '1850px' }}>
                        <thead>
                            <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                                <th scope="col" className="fw-bold text-white py-12 px-16" style={{ width: '70px' }}>Sl.No</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '220px' }}>Expo Name</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '200px' }}>Company Name</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '180px' }}>Key Person</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '220px' }}>Mobile Number</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '180px' }}>Event Manager</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '220px' }}>Recent Feedback</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '200px' }}>Remarks</th>
                                <th scope="col" className="fw-bold text-white py-12 text-center" style={{ width: '120px' }}>Status</th>
                                <th scope="col" className="fw-bold text-white py-12 text-center" style={{ width: '150px' }}>Last Updated</th>
                                <th scope="col" className="fw-bold text-white py-12 text-center" style={{ width: '100px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="11" className="text-center py-24">
                                        <div className="spinner-border text-danger" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : data.length > 0 ? (
                                data.map((item, index) => (
                                    <tr key={item._id || index} className="hover-bg-light transition-all">
                                        <td className="py-10 px-16"><div>{currentPage * rowsPerPage + index + 1}</div></td>
                                        <td className="py-10">
                                            <div>{item.expoId?.expoName || item.expoName || "-"}</div>
                                        </td>
                                        <td className="py-10">
                                            <div>{item.companyName || "-"}</div>
                                        </td>
                                        <td className="py-10"><div>{item.name || "-"}</div></td>
                                        <td className="py-10"><div>{item.mobileNo || "-"}</div></td>
                                        <td className="py-10">
                                            <div>{item.managerId?.name || "-"}</div>
                                        </td>
                                        <td className="py-10"><div>{item.status || "-"}</div></td>
                                        <td className="py-10"><div>{item.remarks || "-"}</div></td>
                                        <td className="text-center py-10">
                                            <span className={`badge px-12 py-4 radius-4 fw-bold ${
                                                item.status === 'Booked' || item.status === 'Active' ? 'bg-success-focus text-success-main' : 
                                                item.status === 'Followup' || item.status === 'Todayfolloup' ? 'bg-info-focus text-info-main' :
                                                'bg-neutral-100 text-neutral-600'
                                            }`} style={{ fontSize: '10px' }}>
                                                {item.status}
                                            </span>
                                        </td>
                                        <td className="text-center py-10 text-nowrap"><div>{formatDate(item.updatedAt) || "-"}</div></td>
                                        <td className="text-center py-10">
                                            <button
                                                type="button"
                                                className="glass-action-btn glass-btn-view mx-auto"
                                                title="View Details"
                                                style={{ width: "30px", height: "30px" }}
                                                onClick={() => {
                                                    setSelectedLead({
                                                        ...item,
                                                        leadStatus: item.status || "Enquiry"
                                                    });
                                                    setShowHistoryModal(true);
                                                }}
                                            >
                                                <Icon
                                                    icon="solar:eye-bold-duotone"
                                                    style={{ fontSize: "16px" }}
                                                />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center py-24 text-secondary-light">
                                        No followups available for today
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="mt-24">
                    <TablePagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalRecords / rowsPerPage)}
                        onPageChange={setCurrentPage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(val) => {
                            setRowsPerPage(val);
                            setCurrentPage(0);
                        }}
                        totalRecords={totalRecords}
                    />
                </div>
            </div>

            {/* Read-Only History Details Modal */}
            {showHistoryModal && selectedLead && (
                <Modal
                    show={showHistoryModal}
                    onHide={() => setShowHistoryModal(false)}
                    size="lg"
                    centered
                    className="lead-history-modal"
                >
                    <Modal.Header closeButton className="bg-light">
                        <Modal.Title className="text-md fw-bold">
                            Interaction Details - {selectedLead.companyName || selectedLead.name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-24">
                        <div className="row g-4">
                            {/* Business details info */}
                            <div className="col-md-6">
                                <div className="p-16 radius-12 bg-neutral-50 border h-100">
                                    <h6 className="text-xs fw-bold text-secondary-light uppercase mb-16 border-bottom pb-8">
                                        Business Details
                                    </h6>
                                    <div className="d-flex flex-column gap-3">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-sm text-secondary-light">
                                                Company Name:
                                            </span>
                                            <span className="text-sm fw-bold text-dark">
                                                {selectedLead.companyName || "-"}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-sm text-secondary-light">
                                                Contact Person:
                                            </span>
                                            <span className="text-sm fw-bold text-dark">
                                                {selectedLead.name || "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-16 radius-12 bg-neutral-50 border h-100">
                                    <h6 className="text-xs fw-bold text-secondary-light uppercase mb-16 border-bottom pb-8">
                                        Contact Details
                                    </h6>
                                    <div className="d-flex flex-column gap-3">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-sm text-secondary-light">
                                                Primary Mobile:
                                            </span>
                                            <div className="text-end">
                                                <span className="text-sm fw-bold text-dark d-block">
                                                    {selectedLead.phone ||
                                                        selectedLead.mobileNo ||
                                                        "N/A"}
                                                </span>
                                                <a
                                                    href={`https://wa.me/${selectedLead.phone || selectedLead.mobileNo}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="text-xs text-success fw-bold d-flex align-items-center gap-1 justify-content-end mt-1"
                                                >
                                                    <Icon icon="ic:baseline-whatsapp" /> Chat on WhatsApp
                                                </a>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-sm text-secondary-light">
                                                Email Address:
                                            </span>
                                            <span className="text-sm fw-bold text-dark">
                                                {selectedLead.email || "N/A"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="p-16 radius-12 bg-white border">
                                    <h6 className="text-xs fw-bold text-secondary-light uppercase mb-16 border-bottom pb-8 d-flex align-items-center justify-content-between flex-wrap gap-2">
                                        <span>Interaction History</span>
                                        <span
                                            className={`badge radius-pill px-12 py-4 ${
                                                selectedLead.status === "Booked"
                                                    ? "bg-success-focus text-success-main"
                                                    : selectedLead.status === "Followup" || selectedLead.status === "Todayfolloup"
                                                    ? "bg-info-focus text-info-main"
                                                    : selectedLead.status === "Rejected"
                                                    ? "bg-danger-focus text-danger-main"
                                                    : "bg-primary-focus text-primary-main"
                                            }`}
                                        >
                                            CURRENT STATUS: {(selectedLead.status || "Enquiry").toUpperCase()}
                                        </span>
                                    </h6>

                                    <div className="timeline-container position-relative ps-20">
                                        <div
                                            className="timeline-line position-absolute h-100 bg-neutral-200"
                                            style={{ width: "2px", left: "6px", top: "0" }}
                                        ></div>

                                        {/* Initial Creation Record */}
                                        <div className="timeline-item position-relative mb-20">
                                            <div
                                                className="timeline-marker position-absolute rounded-circle bg-primary-600"
                                                style={{
                                                    width: "12px",
                                                    height: "12px",
                                                    left: "-19px",
                                                    top: "4px",
                                                    border: "2px solid white",
                                                }}
                                            ></div>
                                            <div className="d-flex justify-content-between mb-4">
                                                <span className="text-sm fw-bold text-dark">
                                                    Initial Enquiry
                                                </span>
                                                <span className="text-xs text-secondary-light">
                                                    {selectedLead.createdAt
                                                        ? new Date(selectedLead.createdAt).toLocaleString("en-GB")
                                                        : ""}
                                                </span>
                                            </div>
                                            <p className="text-sm text-secondary-light mb-0 bg-neutral-50 p-12 radius-8 border italic">
                                                {selectedLead.remarks || "No initial remarks"}
                                            </p>
                                        </div>

                                        {/* Timeline History updates */}
                                        {(selectedLead.statusUpdateDetails || []).map((detail, idx) => (
                                            <div
                                                key={idx}
                                                className="timeline-item position-relative mb-20"
                                            >
                                                <div
                                                    className={`timeline-marker position-absolute rounded-circle ${
                                                        detail.status === "Booked"
                                                            ? "bg-success-500"
                                                            : detail.status === "Followup" || detail.status === "Todayfolloup"
                                                            ? "bg-info-500"
                                                            : detail.status === "Rejected"
                                                            ? "bg-danger-500"
                                                            : "bg-warning-500"
                                                    }`}
                                                    style={{
                                                        width: "12px",
                                                        height: "12px",
                                                        left: "-19px",
                                                        top: "4px",
                                                        border: "2px solid white",
                                                    }}
                                                ></div>
                                                <div className="d-flex justify-content-between mb-4">
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-sm fw-bold text-dark">
                                                            {detail.status}
                                                        </span>
                                                        <span className="text-xxs text-secondary-light">
                                                            (by {detail.createdBy?.name || selectedLead.managerId?.name || "Manager"})
                                                        </span>
                                                    </div>
                                                    <span className="text-xs text-secondary-light">
                                                        {detail.date
                                                            ? new Date(detail.date).toLocaleString("en-GB")
                                                            : ""}
                                                    </span>
                                                </div>
                                                <p className="text-sm text-secondary-light mb-0 bg-neutral-50 p-12 radius-8 border">
                                                    {detail.remark || "No remarks provided"}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setShowHistoryModal(false)}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default TodayFollowupLayer;
